<mat-card id="card" fxLayout="column" class="mainContentBody">
    <mat-card-content fxFlex [style.overflow]="'auto'" fxLayout="column" class="mainContentBodyContent">
        <h2>Dettagli ordine</h2>
        <div fxLayout="column" class="responsive-mat-form">
            <form [formGroup]="form" fxLayout="column">
                <!-- Id field -->
                <mat-form-field>
                    <input matInput formControlName="id" placeholder="Ordine ID" readonly="true" />
                </mat-form-field>

                <!-- Collaboratore field -->
                <mat-form-field fxLayout="column">
                    <mat-label>Collaboratori</mat-label>
                    <mat-select formControlName="collaboratore" [compareWith]="compareDTO"
                        [disabled]="!isJappTenantAdmin()">
                        <mat-option *ngFor="let collaboratore of collaboratori" [value]="collaboratore">
                            {{collaboratore.nome}} {{collaboratore.cognome}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.get('collaboratore').errors?.required">
                        Campo obbligatorio
                    </mat-error>
                </mat-form-field>
                <!-- Comanda field -->
                <mat-form-field fxLayout="column"> 
                    <mat-label>Comanda</mat-label>
                    <mat-select formControlName="comanda" [compareWith]="compareDTO">
                        <mat-option *ngFor="let comanda of comande" (click)="setLink(comanda.link)" [value]="comanda">
                            {{comanda.descrizione}} ({{comanda.collaboratore?.nome}} {{comanda.collaboratore?.cognome}})
                        </mat-option>
                    </mat-select> 
                    <mat-error *ngIf="form.get('comanda').errors?.required">
                        Campo obbligatorio
                    </mat-error>
                </mat-form-field>

                <!-- Link field -->
                <a *ngIf="getLink() !== null" href="{{ getLink() }} " target=”_blank” >Menù</a>

                <!--Descrizione field-->
                <mat-form-field fxFlex="30" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
                    [ngStyle]="{'padding-right': 2 + '%'}" [ngStyle.xs]="{'padding-right.px': 0}"
                    [ngStyle.sm]="{'padding-right.px': 0}" [ngStyle.md]="{'padding-right.px': 0}">
                    <textarea maxlength="100" matInput formControlName="descrizione" placeholder="Descrizione"></textarea>
                    <mat-error *ngIf="form.get('descrizione').errors?.required">
                        Campo obbligatorio
                    </mat-error>
                </mat-form-field>
                <!--Importo dovuto-->
                <mat-form-field fxFlex="30" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
                    [ngStyle]="{'padding-right': 2 + '%'}" [ngStyle.xs]="{'padding-right.px': 0}"
                    [ngStyle.sm]="{'padding-right.px': 0}" [ngStyle.md]="{'padding-right.px': 0}">
                    <input type ="number" step=".01" matInput formControlName="importoDovuto" placeholder="Importo dovuto">
                    <mat-error *ngIf="form.get('importoDovuto').errors?.required">
                        Campo obbligatorio
                    </mat-error>
                </mat-form-field>
                <!-- Campi di informazione operazione -->
                <mat-expansion-panel class="mat-elevation-z0">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            Dettagli operazione
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div fxLayout="row">
                        <!-- InsertDate field -->
                        <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
                            [ngStyle]="{'padding-right': 2 + '%'}" [ngStyle.xs]="{'padding-right.px': 0}"
                            [ngStyle.sm]="{'padding-right.px': 0}" [ngStyle.md]="{'padding-right.px': 0}">
                            <input matInput formControlName="insertDate" placeholder="Insert Date" readonly="true" />
                        </mat-form-field>

                        <!-- InsertUser field -->
                        <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100">
                            <input matInput formControlName="insertUser" placeholder="Insert User" readonly="true" />
                        </mat-form-field>
                    </div>
                    <div fxLayout="row">
                        <!-- UpdateDate field -->
                        <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
                            [ngStyle]="{'padding-right': 2 + '%'}" [ngStyle.xs]="{'padding-right.px': 0}"
                            [ngStyle.sm]="{'padding-right.px': 0}" [ngStyle.md]="{'padding-right.px': 0}">
                            <input matInput formControlName="updateDate" placeholder="Update Date" readonly="true" />
                        </mat-form-field>

                        <!-- UpdateUser field -->
                        <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100">
                            <input matInput formControlName="updateUser" placeholder="Update User" readonly="true" />
                        </mat-form-field>
                    </div>
                </mat-expansion-panel>
            </form>
        </div>
        <mat-card-actions>
            <button mat-raised-button (click)="backConfirm(previousUrl)" color="primary">Back</button>
            <button mat-raised-button (click)="ordineSave()" [disabled]=" !form.dirty || form.invalid"
                *ngIf="ordine?.deleteDate==null">Save</button>
            <button mat-raised-button (click)="ordineDelete()" [disabled]="ordine?.id==null"
                *ngIf="ordine?.deleteDate==null && isJappTenantAdmin()">Delete</button>
        </mat-card-actions>
    </mat-card-content>
</mat-card>